<template>
  <div>
    <div style="text-align:right;padding:10px; background: #fff;">
      <el-button @click="clickPrintBtn" type="primary">打印</el-button>
    </div>
    <div style="background-color:white;padding: 15pt 15pt 50pt 15pt;">
      <div class="printArea">
        <tableHeader
        ></tableHeader>
      </div>
    </div>
  </div>
</template>

<script>
import tableHeader from './body.vue'
export default {
  data() {
    return {
    };
  },
  components: {
    tableHeader
  },
  methods: {
    // 点击打印
    clickPrintBtn: function() {
      printHtmlWindow("printArea", "打印面辅料核价");
      function printHtmlWindow(el = "printArea", title = "打印面辅料核价") {
        let timer;
        const newHtml = document.getElementsByClassName(el)[0].innerHTML;
        const newWindow = window.open(title, "_blank");
        const head =
          '<html><head><link href="/static/resources/font-awesome.min.css" rel="stylesheet" type="text/css"><link href="element-ui/lib/theme-default/index.css" rel="stylesheet" type="text/css"><link href="/static/resources/table.css" rel="stylesheet" type="text/css"><body class="P66_print_window">';
        const foot =
          '</body></html><style type="text/css">table{border-collapse: collapse;}.styleTable tr th {border: 1px solid #000000;width: 3%;}.styleTable tr td {border: 1px solid #000000;width: 3%;}.font-header{font-size: 150%;}.position{position: relative;bottom:50px;}.pageBreak{page-break-after: always;}</style>';
        newWindow.document.write(head);
        newWindow.document.write(newHtml);
        newWindow.document.write(foot);

        // 监听页面重新渲染后再打印
        // 拿最后一次resize结果
        newWindow.onresize = function() {
          clearTimeout(timer);
          timer = setTimeout(() => {
            newWindow.print();
            newWindow.close();
          }, 500);
        };
      }
    }
  }
}
</script>